<template>
  <div class="layout--full-page">
    <router-view></router-view>
  </div>
</template>
<script>
import EventBus from "@/services/eventBusService"

export default {
  created() {
    EventBus.$on('network-error', (val) => {
      if (val) {
        this.$vs.notify({
          title: 'การเชื่อมต่อมีปัญหา!',
          text: 'กรุณาตรวจสอบการเชื่อมต่ออินเตอร์เน็ต',
          iconPack: 'feather',
          icon: 'icon-alert-circle',
          color: 'danger'
        });
      }
    })
  },
  beforeDestroy() {
    EventBus.$off('network-error')
  }
}

</script>
